import Cookies from 'js-cookie'
const classSotre = {
  state: {
    changeOneStepDate: {},
    towStepData:[],
    splitClassData:{},
  },
  mutations: {

    CHANGE_ONE_STEP: (state, data) => {
      state.changeOneStepDate = data
    },
    TOW_STEP_DATA:(state, data) => {

      state.towStepData = data.data;
      // console.log("step1", state.towStepData);
    },

    SET_SPLIT_CLASS_DATA:(state, data) => {
      state.splitClassData = data.data;
    },

  },
  actions: {
    changeOneStepDate({ commit }, { data }) {
      commit('CHANGE_ONE_STEP', { data })
    },
    twoStepDatar({ commit },{ data }) {
      commit('TOW_STEP_DATA',{ data })
    },
    setSplitClassData({ commit },{ data }) {
      commit('SET_SPLIT_CLASS_DATA',{ data })
    }
  }
}

export default classSotre

